// extracted by mini-css-extract-plugin
export default {"qrCodeModal":"Qrscan_qrCodeModal__MTm7n","qrVideo":"Qrscan_qrVideo__RMSXJ","qrResult":"Qrscan_qrResult__Hvq5Q"};